import { render, staticRenderFns } from "./CommonTable.vue?vue&type=template&id=60982946&"
import script from "./CommonTable.vue?vue&type=script&lang=js&"
export * from "./CommonTable.vue?vue&type=script&lang=js&"
import style0 from "./CommonTable.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports